import React, { memo, useCallback } from 'react';

// Componente para campos de fecha
const DateField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="date"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de hora
const TimeField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="time"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de fecha y hora
const DateTimeField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="datetime-local"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

DateField.displayName = 'DateField';
TimeField.displayName = 'TimeField';
DateTimeField.displayName = 'DateTimeField';

export {
  DateField,
  TimeField,
  DateTimeField
};